export const actionColumnWidth = '245px';
